import script from "./SelectNoteUser.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectNoteUser.vue?vue&type=script&setup=true&lang=js"

import "./SelectNoteUser.vue?vue&type=style&index=0&id=644aeef3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644aeef3"]])

export default __exports__